import {
  CLOSE_INFOWINDOWS_SOCIOECONOMIC_DEMOGRAPHIC,
  SET_INFOWINDOWS_SOCIOECONOMIC_DEMOGRAPHIC,
  ADD_GEOCODE_SOCIOECONOMIC_DEMOGRAPHIC,
  RESET_GEOCODE_SOCIOECONOMIC_DEMOGRAPHIC,
  UPDATE_MODAL_DATA_SOCIOECONOMIC_DEMOGRAPHIC,
  UPDATE_MODAL_CHARTS_SOCIOECONOMIC_DEMOGRAPHIC,
  UPDATE_MODAL_TABLES_SOCIOECONOMIC_DEMOGRAPHIC,
  UPDATE_ERROR_FETCH_DATA_SOCIOECONOMIC_DEMOGRAPHIC,
  CLEAN_POLYGONS_ON_MAP_SOCIOECONOMIC_DEMOGRAPHIC,
  UPDATE_TABLES_DATA_SOCIOECONOMIC_DEMOGRAPHIC,
  UPDATE_CHARTS_DATA_SOCIOECONOMIC_DEMOGRAPHIC,
  UPDATE_ERROR_FETCH_DATA,
  RESET_ERROR_FETCH_DATA,
} from './socioeconomicDemographic.actions';

const initialState = {
  displayBigNumbersSocioeconomicDemographic: false,
  displayChartsSocioeconomicDemographic: false,
  infoWindowsSocioeconomicDemographic: [],
  geocodePayload: [],
  shouldCleanPolygonsOnMap: false,
  buildingModalData: {
    sector: '',
    info: [],
    chartsData: {
      dwellersByResidence: [],
      typesOfResidence: [],
      residenceCondition: [],
      genderDistribution: [],
      activePopulation: [],
      consumptionByGoods: [],
    },
    tablesData: {
      ageDistribution: [],
      populationGrowth: [],
      householdsByIncome: [],
      consumptionByIncome: [],
    },
    errorFetchData: {
      typesOfResidence: false,
      residenceCondition: false,
      dwellersByResidence: false,
      genderDistribution: false,
      ageDistribution: false,
      populationGrowth: false,
      householdsByIncome: false,
      activePopulation: false,
      consumptionByIncome: false,
      consumptionByGoods: false,
    },
  },
  chartsDataSocioeconomicDemographic: {
    dwellersByResidence: [],
    typesOfResidence: [],
    residenceCondition: [],
    genderDistribution: [],
    activePopulation: [],
    consumptionByGoods: [],
  },
  tablesDataSocioeconomicDemographic: {
    ageDistribution: [],
    populationGrowth: [],
    householdsByIncome: [],
    consumptionByIncome: [],
  },
  errorFetchData: {
    typesOfResidence: false,
    residenceCondition: false,
    dwellersByResidence: false,
    genderDistribution: false,
    ageDistribution: false,
    populationGrowth: false,
    householdsByIncome: false,
    activePopulation: false,
    consumptionByIncome: false,
    consumptionByGoods: false,
  },
};

export default function socioeconomicDemographicReducer(
  state = initialState,
  { type, payload }
) {
  switch (type) {
    case CLEAN_POLYGONS_ON_MAP_SOCIOECONOMIC_DEMOGRAPHIC:
      return { ...state, shouldCleanPolygonsOnMap: payload };
    case SET_INFOWINDOWS_SOCIOECONOMIC_DEMOGRAPHIC:
      return { ...state, infoWindowsSocioeconomicDemographic: [payload] };
    case UPDATE_ERROR_FETCH_DATA_SOCIOECONOMIC_DEMOGRAPHIC:
      return {
        ...state,
        buildingModalData: {
          ...state.buildingModalData,
          errorFetchData: {
            ...state.buildingModalData.errorFetchData,
            [payload.name]: payload.value,
          },
        },
      };
    case UPDATE_MODAL_DATA_SOCIOECONOMIC_DEMOGRAPHIC:
      return {
        ...state,
        buildingModalData: { ...state.buildingModalData, ...payload },
      };
    case UPDATE_MODAL_CHARTS_SOCIOECONOMIC_DEMOGRAPHIC:
      return {
        ...state,
        buildingModalData: {
          ...state.buildingModalData,
          chartsData: {
            ...state.buildingModalData.chartsData,
            ...payload,
          },
        },
      };
    case UPDATE_MODAL_TABLES_SOCIOECONOMIC_DEMOGRAPHIC:
      return {
        ...state,
        buildingModalData: {
          ...state.buildingModalData,
          tablesData: {
            ...state.buildingModalData.tablesData,
            ...payload,
          },
        },
      };
    case ADD_GEOCODE_SOCIOECONOMIC_DEMOGRAPHIC:
      return { ...state, geocodePayload: [...state.geocodePayload, payload] };
    case RESET_GEOCODE_SOCIOECONOMIC_DEMOGRAPHIC:
      return { ...state, geocodePayload: [] };
    case CLOSE_INFOWINDOWS_SOCIOECONOMIC_DEMOGRAPHIC:
      state.infoWindowsSocioeconomicDemographic?.forEach((iw) => iw.close());
      return state;
    case UPDATE_TABLES_DATA_SOCIOECONOMIC_DEMOGRAPHIC:
      return {
        ...state,
        tablesDataSocioeconomicDemographic: {
          ...state.tablesDataSocioeconomicDemographic,
          [payload.name]: payload.value,
        },
      };
    case UPDATE_CHARTS_DATA_SOCIOECONOMIC_DEMOGRAPHIC:
      return {
        ...state,
        chartsDataSocioeconomicDemographic: {
          ...state.chartsDataSocioeconomicDemographic,
          [payload.name]: payload.value,
        },
      };
    case UPDATE_ERROR_FETCH_DATA:
      return {
        ...state,
        errorFetchData: {
          ...state.errorFetchData,
          [payload.name]: payload.value,
        },
      };
    case RESET_ERROR_FETCH_DATA:
      return {
        ...state,
        errorFetchData: {
          typesOfResidence: false,
          residenceCondition: false,
          dwellersByResidence: false,
          genderDistribution: false,
          ageDistribution: false,
          populationGrowth: false,
          householdsByIncome: false,
          activePopulation: false,
        },
      };
    default:
      return state;
  }
}
